import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Typography from '../../../../../components/Typography';
import { i18nNS } from '../../../../../i18n';
import AcadlyLogoSquareIcon from '../../../../../icons/AcadlyLogoSquare';
import BluetoothIcon from '../../../../../icons/BluetoothIcon';
import PhoneIcon from '../../../../../icons/PhoneIcon';
import WebIcon from '../../../../../icons/WebIcon';
import InnerLayout from '../InnerLayout';
import InstructionBox from './InstructionBox';
import RecordAttendanceAction from './RecordAttendanceAction';

const RecordAttendanceScreen = () => {
  const { t } = useTranslation([i18nNS.CLASS]);

  return (
    <Stack justifyContent="center" alignItems="center" height="100%">
      <InnerLayout>
        <Stack gap={4} height="100%">
          <Stack key="fixed-key" flex={1} alignItems="center" gap={4} p={3}>
            <Typography variant="h6Bold" color="warning.500" textTransform="uppercase">
              {t('please_ensure', { ns: i18nNS.CLASS })}
            </Typography>
            <InstructionBox
              icon={<PhoneIcon size={30} color="warning.400" />}
              label={t('acadly_app_is_open_on_your_phone', { ns: i18nNS.CLASS })}
            />
            <InstructionBox
              icon={<WebIcon size={30} color="warning.400" />}
              label={t('your_phone_is_connected_to_the_internet', { ns: i18nNS.CLASS })}
            />
            <InstructionBox
              icon={<AcadlyLogoSquareIcon size={30} />}
              label={t('you_are_logged_in_to_acadly', { ns: i18nNS.CLASS })}
            />
            <InstructionBox
              icon={<BluetoothIcon size={30} color="warning.400" />}
              label={t('acadly_app_has_all_required_permissions', { ns: i18nNS.CLASS })}
            />
          </Stack>
          <RecordAttendanceAction />
        </Stack>
      </InnerLayout>
    </Stack>
  );
};

export default RecordAttendanceScreen;
